/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontSocial_seller = {
    readonly trackedPhone: {
        readonly phoneNumber: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontContactButton_seller" | "StorefrontCallButton_seller" | "StorefrontSocialShare_seller">;
    readonly " $refType": "StorefrontSocial_seller";
};
export type StorefrontSocial_seller$data = StorefrontSocial_seller;
export type StorefrontSocial_seller$key = {
    readonly " $data"?: StorefrontSocial_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontSocial_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "StorefrontSocial_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "trackedPhone",
      "storageKey": null,
      "args": null,
      "concreteType": "Phone",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "phoneNumber",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontContactButton_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontCallButton_seller",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "StorefrontSocialShare_seller",
      "args": null
    }
  ]
};
(node as any).hash = '37599e40e9e9137722e3543f09cb3b86';
export default node;
